import { PaginationDto, Sort } from '../types/miscelaneos/pagination'

interface PaginationProps {
  pagination?: PaginationDto
  sort?: Sort
  group?: string
}

// export const paginationString = ({ pagination, sort, group }: PaginationProps): string => {
//   const sortString = sort ? `sortField=${sort.sortField}&sortDirection=${sort.sortDirection}` : '';
//   const groupString = group ? `&group=${group}` : '';
//   const groupOffset = `&offset=${pagination?.offset && pagination?.offset >= 0 ? pagination?.offset : Number(pagination?.limit) * Number(pagination?.page) || 0}`;
//   const paginationString = `page=${pagination?.page || 0}&limit=${pagination?.limit || 100}`

//   return `?${paginationString}${sortString !== '' ? '&' : ''}${sortString}${groupString}${groupOffset}`
// }

export const paginationString = ({ pagination, sort, group }: PaginationProps): string => {
  const sortString = sort ? `sortField=${sort.sortField}&sortDirection=${sort.sortDirection}` : '';
  const groupString = group ? `&group=${group}` : '';

  // Si limit es undefined o cero, se utilizará 100 como valor por defecto.
  const limit = pagination?.limit !== undefined ? pagination?.limit : 100;

  // Calculamos el offset, teniendo en cuenta que offset puede ser 0 o mayor.
  const offset = pagination?.offset !== undefined && pagination?.offset >= 0
    ? pagination?.offset
    : limit * (pagination?.page || 0);

  const paginationString = `page=${pagination?.page || 0}&limit=${limit}&offset=${offset}`;

  return `?${paginationString}${sortString ? `&${sortString}` : ''}${groupString}`;
};